(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  $(function() {
    $('.header__cart-icon').click(function () {
      CartDrawer.update();
    });
    
    $("#CartDrawer").on('click', '#shipping_insurance', function () {
      var insuranceFee = removeCurrency($('#insurance_fee').html());
      var subtotalPrice = removeCurrency($('.cart-drawer-subtotal__price').html());
      var selectShippingInsurance = $(this).is(':checked');
      if (selectShippingInsurance) {
        localStorage.setItem(productInsurance.key, 1);
        subtotalPrice = insuranceFee + subtotalPrice;
      } else {
        localStorage.setItem(productInsurance.key, 0);
        subtotalPrice = subtotalPrice - insuranceFee;
      }
      $('.cart-drawer-subtotal__price').html(formatCurrency(subtotalPrice))
    });
    
    $("#CartDrawer").on('click', '#checkout', function (event) {
      var cartForm = $('#CartDrawerForm');
      cartForm.attr('action', '/checkout');
      
      event.preventDefault();
      //CartDrawer.update();
      $(this).addClass('loading');
      $(this).prop('disabled', true);

      var selectShippingInsurance = $('#shipping_insurance').is(':checked');
      console.log(selectShippingInsurance);
      if (selectShippingInsurance) {
        var insuranceFee = removeCurrency($('#insurance_fee').html());
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            id: productInsurance.product_id,
            quantity: insuranceFee
          })
        })
        .then(response => response.json())
        .then(data => {
          // 将保费商品加入购物车后，需要手动触发额外获取一次购物车信息，不然页面回退的时候，触发自动获取购物车信息的时候，里面没有保费产品，会影响保费产品自动删除的逻辑
          fetch('/cart.js').then(response => response.json()).then(cart => {
            setTimeout(function () {
              $('#CartDrawerForm').submit();
            }, 200);
          });
        })
        .catch(error => console.error('Error:', error));
      } else {
        $('#CartDrawerForm').submit();
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  $(function() {
    productInsurance.calc('CartPage');
    
    $("#shopping_insurance_option").on('click', '#shipping_insurance', function () {
      var insuranceFee = removeCurrency($('#insurance_fee').html());
      var subtotalPrice = removeCurrency($('.cart-subtotal__totals-price').html());
      var selectShippingInsurance = $(this).is(':checked');
      if (selectShippingInsurance) {
        localStorage.setItem(productInsurance.key, 1);
        subtotalPrice = insuranceFee + subtotalPrice;
      } else {
        localStorage.setItem(productInsurance.key, 0);
        subtotalPrice = subtotalPrice - insuranceFee;
      }
      $('.cart-subtotal__totals-price').html(formatCurrency(subtotalPrice))
    });
    
    $("#CartPage").on('click', '#checkout', function (event) {
      var cartForm = $('#CartPageForm');
      cartForm.attr('action', '/checkout');
      
      event.preventDefault();
      //CartDrawer.update();
      $(this).addClass('loading');
      $(this).prop('disabled', true);

      var selectShippingInsurance = $('#shipping_insurance').is(':checked');
      if (selectShippingInsurance) {
        var insuranceFee = removeCurrency($('#insurance_fee').html());
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            id: productInsurance.product_id,
            quantity: insuranceFee
          })
        })
        .then(response => response.json())
        .then(data => {
          // 将保费商品加入购物车后，需要手动触发额外获取一次购物车信息，不然页面回退的时候，触发自动获取购物车信息的时候，里面没有保费产品，会影响保费产品自动删除的逻辑
          fetch('/cart.js').then(response => response.json()).then(cart => {
            $('#CartPageForm').submit();
          });
        })
        .catch(error => console.error('Error:', error));
      } else {
        $('#CartPageForm').submit();
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer-login"]) return;
  try {
    
  $(function() {
    $('#customer_login .login__btn').on('click', function(event) {
      event.preventDefault();
      var email = $("#customer_login input[type='email']").val();
      var password = $("#customer_login input[type='password']").val();
      var query = `
          mutation {
              customerAccessTokenCreate(input: {email: "${email}", password: "${password}"}) {
                  customerAccessToken {
                      accessToken
                      expiresAt
                  }
                  userErrors {
                      field
                      message
                  }
              }
          }
      `;
      var urlParams = window.getUrlParams();
      var customerfrom = "";
      if (urlParams['checkout_url']) {
          customerfrom = "checkout";
      }
      window.dataLayer = window.dataLayer || [];
      dataLayer.push({
        event: "click_signin",
        cus_params: {
            from: customerfrom,
            client_id: clientId,
        }
      });
      $(this).addClass('loading');
      $(this).prop('disabled', true);
      $.ajax({
          url: '/api/2023-04/graphql.json', // 或 /api/unstable/graphql.json
          method: 'POST',
          headers: {
            'X-Shopify-Storefront-Access-Token': storefrontAccessToken,
            'Content-Type': 'application/json'
          },
          contentType: 'application/json',
          data: JSON.stringify({ query: query }),
          success: function(response) {
              var data = response.data.customerAccessTokenCreate;
              if (data.customerAccessToken) {
                  var accessToken = data.customerAccessToken.accessToken;
                  getUserInfo(accessToken);
              } else if (data.userErrors.length > 0) {
                  $('#customer_login .login__btn').removeClass('loading');
                  $('#customer_login .login__btn').prop('disabled', false);

                  window.showGlobalNotification("Login failed: " + data.userErrors[0].message);
              }
          },
          error: function(xhr, status, error) {
            $('#customer_login .login__btn').removeClass('loading');
            $('#customer_login .login__btn').prop('disabled', false);

            window.showGlobalNotification("An error occurred. Please try again.");
          }
      });
    });

    function getUserInfo(accessToken) {
        $.ajax({
            url: '/api/2023-04/graphql.json',
            method: 'POST',
            headers: {
                'X-Shopify-Storefront-Access-Token': storefrontAccessToken,
                'Content-Type': 'application/json'
            },
            data: JSON.stringify({
                query: `
                {
                    customer(customerAccessToken: "${accessToken}") {
                        id
                        email
                    }
                }`
            }),
            success: function(response) {
                $('#customer_login .login__btn').removeClass('loading');
                $('#customer_login .login__btn').prop('disabled', false);
                var customer = response.data.customer;
                if(customer){
                  var gid = customer.id;
                  var parts = gid.split('/');
                  var customerId = parts[parts.length - 1];
                  var urlParams = window.getUrlParams();
                  var customerfrom = "";
                  if (urlParams['checkout_url']) {
                      customerfrom = "checkout";
                  }
                  if (urlParams['from']) {
                      customerfrom = urlParams['from'];
                  }
                  window.dataLayer = window.dataLayer || [];
                  dataLayer.push({
                    event: "signin_success",
                    cus_params: {
                        landing_page: getLandingPageCookie(),
                        id: customerId,
                        from: customerfrom,
                        client_id: clientId,
                    }
                  });
                  localStorage.setItem('loginSuccessTriggered', 'true');
                  $('#customer_login').submit();
                }else{
                  window.showGlobalNotification("Login failed: " + response.data.errors[0].message);
                }
            },
            error: function(xhr, status, error) {
                $('#customer_login .login__btn').removeClass('loading');
                $('#customer_login .login__btn').prop('disabled', false);
                window.showGlobalNotification("An error occurred. Please try again.");
            }
        });
    }

    const urlParams = new URLSearchParams(window.location.search);
    const paramValue = urlParams.get('return_to');
    const emailparamValue = urlParams.get('email');
    if(emailparamValue){
      $("#customer_login input[type='email']").val(emailparamValue);
    }
    if(paramValue){
      $('#customer_login input[name="return_to"]').val(paramValue);
    }
    $('#customer_login .login__footer a').attr('href', $('#customer_login .login__footer a').attr('href') + window.location.search);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer-register"]) return;
  try {
    
  $(function() {
    $('#create_customer .login__btn').on('click', function(event) {
      event.preventDefault();
      var firstName = $("#create_customer input[name='customer[first_name]']").val();
      var lastName = $("#create_customer input[name='customer[last_name]']").val();
      var email = $("#create_customer input[name='customer[email]']").val();
      var password = $("#create_customer input[name='customer[password]']").val();
      var query = `
            mutation customerCreate($input: CustomerCreateInput!) {
                customerCreate(input: $input) {
                    customer {
                        id
                        email
                        firstName
                        lastName
                        acceptsMarketing
                    }
                    customerUserErrors {
                        code
                        field
                        message
                    }
                }
            }
        `;

        var variables = {
            input: {
                email: email,
                password: password,
                firstName: firstName,
                lastName: lastName,
                acceptsMarketing: true
            }
        };
        var urlParams = window.getUrlParams();
        var customerfrom = "";
        if (urlParams['checkout_url']) {
            customerfrom = "checkout";
        }
        window.dataLayer = window.dataLayer || [];
        dataLayer.push({
          event: "click_signup",
          cus_params: {
              from: customerfrom,
              client_id: clientId,
          }
        });
        $(this).addClass('loading');
        $(this).prop('disabled', true);
        $.ajax({
            url: '/api/2023-04/graphql.json', // 注意API版本
            method: 'POST',
            headers: {
              'X-Shopify-Storefront-Access-Token': storefrontAccessToken,
              'Content-Type': 'application/json'
            },
            data: JSON.stringify({
                query: query,
                variables: variables
            }),
            success: function(response) {
                $('#create_customer .login__btn').removeClass('loading');
                $('#create_customer .login__btn').prop('disabled', false);
              
                var customerData = response.data.customerCreate;

                if (customerData.customerUserErrors.length > 0) {
                    window.showGlobalNotification('Error: ' + customerData.customerUserErrors[0].message);
                } else {
                    localStorage.removeItem('isRegistered');
                  
                    var gid = customerData.customer.id;
                    var parts = gid.split('/');
                    var customerId = parts[parts.length - 1];
                    var urlParams = window.getUrlParams();
                    var customerfrom = "";
                    if (urlParams['checkout_url']) {
                      customerfrom = "checkout";
                    }
                    if (urlParams['from']) {
                        customerfrom = urlParams['from'];
                    }
                    window.dataLayer = window.dataLayer || [];
                    dataLayer.push({
                        event: "signup_success",
                        cus_params: {
                          landing_page: getLandingPageCookie(),
                          id: customerId,
                          from: customerfrom,
                          client_id: clientId,
                        }
                    });

                    $("#customer_login input[type='email']").val(email);
                    $("#customer_login input[type='password']").val(password);
                    $('#customer_login').submit();
                }
            },
            error: function(xhr, status, error) {
                $('#create_customer .login__btn').removeClass('loading');
                $('#create_customer .login__btn').prop('disabled', false);

                window.showGlobalNotification("An error occurred while registering. Please try again.");
            }
        });
    });

    const urlParams = new URLSearchParams(window.location.search);
    const paramValue = urlParams.get('return_to');
    const emailparamValue = urlParams.get('email');
    if(emailparamValue){
      $("#create_customer input[type='email']").val(emailparamValue);
    }
    if(paramValue){
      $('#customer_login input[name="return_to"]').val(paramValue);
    }
    $('#create_customer .login__footer a').attr('href', $('#create_customer .login__footer a').attr('href') + window.location.search);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
$(function(){
  document.getElementById('ContactFooter').addEventListener('submit', function(event) {
    var email = $('#ContactFooter input[type="email"]').val();
    localStorage.setItem('subscribeemail', email);
    window.dataLayer = window.dataLayer || [];
    dataLayer.push({
        event: "subscribe_click",
        cus_params: {
            user_id: CustomerId, //用户id
            email: email, //客户邮箱
            cus_email: btoa(email), //客户邮箱base64加密
            from: "footer", //来源
        }
    });
  });
  $(document).on('submit', 'popup-signup form', function(event) {
    var email = $('popup-signup form input[type="email"]').val();
    localStorage.setItem('subscribeemail', email);
    window.dataLayer = window.dataLayer || [];
    dataLayer.push({
        event: "subscribe_click",
        cus_params: {
            user_id: CustomerId, //用户id
            email: email, //客户邮箱
            cus_email: btoa(email), //客户邮箱base64加密
            from: "popup", //来源
        }
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["logo-list"] && !Shopify.designMode) return;
  try {
    
  $(function() {
    if ($(window).width() > 768) {
      $('.logo-list.color-custom-6 .slider-grid__slide').eq(0).addClass('active');
      $('.logo-list.color-custom-6 .slider-grid__slide').hover(
        function () {
          $(this).siblings().removeClass('active');
          $(this).addClass('active');
        },
        function () {
          
        }
      );
    }
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-become-an-affiliate"]) return;
  try {
    
  $(document).ready(function() {
    $('.wd-page-affiliate-FAQ-item').on('click', function(event) {
      $(this).siblings().find('.wd-page-affiliate-FAQ-item-answer').slideUp(300);
      
      $(this).siblings().find('.wd-page-affiliate-FAQ-item-icon-show').show();
      $(this).siblings().find('.wd-page-affiliate-FAQ-item-icon-hide').hide();
      
      if ($(this).find('.wd-page-affiliate-FAQ-item-answer').is(':visible')) {
        $(this).find('.wd-page-affiliate-FAQ-item-icon-show').show();
        $(this).find('.wd-page-affiliate-FAQ-item-icon-hide').hide();
      } else {
        $(this).find('.wd-page-affiliate-FAQ-item-icon-show').hide();
        $(this).find('.wd-page-affiliate-FAQ-item-icon-hide').show();
      }
      $(this).find('.wd-page-affiliate-FAQ-item-answer').slideToggle(300);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page_absolute-video"]) return;
  try {
    
    $(function(){
        var playerm;
        $(".js-video-url-open").off("click").on("click", function(e){
            if($(this).data('videourl')){
                $('.absolute-video').show();
                playerm=new Player({
                    id: 'absolute-video',
                    url: $(this).data('videourl'),
                    autoplay: true,
                    fluid: true,
                    playsinline: true,
                })
                playerm.start();
                var playPromise = playerm.play();
                if (playPromise !== undefined) {
                    playPromise.then(_ => {
                    // Automatic playback started!
                    // Show playing UI.
                    })
                    .catch(error => {
                    // Auto-play was prevented
                    // Show paused UI.
                    });
                }
    
                if($(this).parents('.home-Kahh-Spence').length){
                    $('.absolute-video').addClass('Kahh-Spence-absolute-video');
                }else{
                    $('.absolute-video').removeClass('Kahh-Spence-absolute-video');
                }
            }
        });
        $(".absolute-video .videopopup_icon_m_close, .absolute-video .absolute-video-con-msk").click(function(){
            playerm.destroy();
            $('.absolute-video').hide();
        });
    })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page_compare"]) return;
  try {
    
  document.getElementById('backButton').onclick = function() {
    history.go(-1);
    // window.location.replace('/');
  };
  $(function(){
      $('.js-Compare').click(function () {
          const index = $(this).attr('data-index');
          $('.Compare-module').toggleClass("Compare-open");
          $("body").toggleClass('keswigs_overflow');
          $('.Compare-scroll').scrollTop(0);
      })
      $('.js-Compare-close').click(function () {
          $('.Compare-module').toggleClass("Compare-open");
          $("body").toggleClass('keswigs_overflow');
      })
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recently-viewed"] && !Shopify.designMode) return;
  try {
    
  $(function() {
    $(document).on('click', '.recently-viewed product-card a, .recently-viewed .gtm-quickview-btn', function() {
      var item = {
        location_name: $(this).parents('recently-viewed').attr('data-page_location_name'),
        id: $(this).parents('product-card').attr('data-id'),
        url: $(this).parents('product-card').attr('data-url'),
        title: $(this).parents('product-card').attr('data-title'),
        price: Currency_Price_Format($(this).parents('product-card').attr('data-price')),
        image_id: $(this).parents('product-card').attr('data-image-id'),
        image_url: $(this).parents('product-card').attr('data-image-url'),
        position: $(this).parents('.slider-grid__slide').index() + 1,
        button_name: $(this).attr('gtm-button-name'),
      }
      window.dataLayer = window.dataLayer || [];
      dataLayer.push({
        event: "click_recently_viewed_item",
        cus_params: item,
      });
    });
    $(document).on('click', '.recently-viewed .card-carousel__position-btn-wrap--prev, .recently-viewed .card-carousel__carousel-btn--next', function() {
        window.dataLayer = window.dataLayer || [];
        dataLayer.push({
          event: "click_recently_viewed_arrow",
          cus_params: {
            location_name: $(this).parents('recently-viewed').attr('data-page_location_name'),
            quantity: $(this).parents('slider-grid').find('.slider-grid__slide').length,
          },
        });
      });
  });

  } catch(e) { console.error(e); }
})();
})();
